import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../lib/api';
import { playPing } from '../lib/sounds';

const POLL_MS = 30000;

// Polls the token feed and toasts when someone forges a new coin — gives the
// whole app a live, communal feel without needing websockets.
const NewLaunchNotifier = () => {
  const lastSeen = useRef(null);
  const nav = useNavigate();

  useEffect(() => {
    let stop = false;
    const check = async () => {
      try {
        const { data } = await axios.get(`${API}/tokens?limit=5`);
        if (stop || !Array.isArray(data) || data.length === 0) return;
        const newest = data[0].created_at;
        if (lastSeen.current) {
          const fresh = data.filter((t) => new Date(t.created_at) > new Date(lastSeen.current));
          if (fresh.length > 0) {
            playPing();
            fresh.slice(0, 3).reverse().forEach((t) => {
              toast(`New coin forged: ${t.name} ($${t.symbol})`, {
                description: `Live on ${t.chain_name || `chain ${t.chain_id}`}`,
                action: {
                  label: 'View',
                  onClick: () => nav(`/token/${t.contract_address}?chain=${t.chain_id}`),
                },
              });
            });
          }
        }
        lastSeen.current = newest;
      } catch (_) { /* transient network error — retry next poll */ }
    };
    check();
    const id = setInterval(check, POLL_MS);
    return () => { stop = true; clearInterval(id); };
  }, [nav]);

  return null;
};

export default NewLaunchNotifier;
